import { j as o, c as l } from "./utils-BdNIfrGQ.js";
import { c as a } from "./index-Di82Y7n3.js";
import { n as p } from "./normalize-spacing-DY0KSpr_.js";
import { D as s } from "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import "./Flex-BA9xHq_p.js";
import "./Grid-DJGISvmf.js";
import "react";
const v = a(
  "flex text-base w-full border border-gray-400 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 read-only:bg-gray-300",
  {
    variants: {
      variant: {
        default: "px-4 py-2",
        primary: "py-4 pl-5 pr-4 rounded-r-[25px]",
        search: "py-4 pl-5 pr-4 rounded-r-[25px] h-[54px]"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), f = a("flex flex-col", {
  variants: {
    size: {
      default: "",
      full: "w-full"
    },
    align: {
      left: "items-start",
      center: "items-center"
    },
    gap: {
      none: "gap-0",
      sm: "gap-2",
      md: "gap-3",
      lg: "gap-4",
      xl: "gap-5",
      "2xl": "gap-6"
    }
  },
  defaultVariants: {
    align: "left"
  }
}), V = ({
  align: r,
  children: t,
  spacing: e,
  gap: i,
  size: n
}) => /* @__PURE__ */ o.jsx(s, { className: l(f({ align: r, gap: i, size: n }), p(e)), children: t });
export {
  V as I,
  v as i
};
